import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardBody } from "reactstrap";

const MilesTypeExplain = ({ container, job }) => {
  return (
    <>
      {job && job.market != "dispatch_job" && (
        <Card className="bg-light mt-3">
          <CardBody>
            <h3>{container.localeManager.strings.truckMode}</h3>
            <div className="fs-4">
              {container.localeManager.strings.milesStats}
            </div>
            <div>
              <FontAwesomeIcon
                icon="tachometer-alt"
                className="text-success"
              ></FontAwesomeIcon>{" "}
              {container.localeManager.strings.realMilesExplain}
              <br />
              <FontAwesomeIcon
                icon="tachometer-alt"
                className="text-danger"
              ></FontAwesomeIcon>{" "}
              {container.localeManager.strings.raceMilesExplain}
              <br />
              <FontAwesomeIcon
                icon="tachometer-alt"
                className="text-muted"
              ></FontAwesomeIcon>{" "}
              {container.localeManager.strings.invalidMilesExplain}
            </div>
          </CardBody>
        </Card>
      )}
      {job && job.market == "dispatch_job" && (
        <Card className="bg-light mt-3">
          <CardBody>
            <h3>{container.localeManager.strings.dispatch_job}</h3>
            <div className="fs-4">
              {container.localeManager.strings.milesStats}
            </div>
            <div>
              <FontAwesomeIcon
                icon="tachometer-alt"
                className="text-success"
              ></FontAwesomeIcon>{" "}
              {container.localeManager.strings.realMilesExplainRoadTrip}
              <br />
              <FontAwesomeIcon
                icon="tachometer-alt"
                className="text-danger"
              ></FontAwesomeIcon>{" "}
              {container.localeManager.strings.raceMilesExplain}
              <br />
              <FontAwesomeIcon
                icon="tachometer-alt"
                className="text-muted"
              ></FontAwesomeIcon>{" "}
              {container.localeManager.strings.invalidMilesExplain}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default MilesTypeExplain;
